import storage from 'controllers/storage';
import URL_PARAMETERS from 'settings/url-parameters';
import _ from 'underscore';
import parseUrl from './parse-url';

const getLocale = () => {
	let locale = 'en';
	const parsedUrl = parseUrl(window.location.href);
	const urlVars = parsedUrl.parameters;

	if (urlVars[URL_PARAMETERS.language]) {
		locale = urlVars[URL_PARAMETERS.language];
	} else if (urlVars[URL_PARAMETERS.locale]) {
		// Backwards compatability - locale parameter has been replaced with language
		locale = urlVars[URL_PARAMETERS.locale];
	} else if (storage.get('locale')) {
		locale = storage.get('locale');
	} else if (typeof navigator !== 'undefined') {
		locale = ((navigator.languages && navigator.languages[0]) || navigator.language || navigator.userLanguage || 'en').toLowerCase();
	}

	// Normalize locale string
	locale = locale.replace(
		'_',
		'-',
	);
	if (locale.indexOf('-') >= 0) {
		/*
		 * Follow ISO norm for locale
		 * e.g. en-US, fr-FR, etc.
		 * Split on '-' and ensure country code is uppercase
		 * e.g. en-us -> en-US
		 *      en -> en
		 */
		const language = locale.split('-')[0];
		const country = locale.split('-')[1];
		locale = `${language}${country ? `-${country.toUpperCase()}` : ''}`;
	}

	/**
	 * Norwegian: browsers/OSes commonly report Bokmål/Nynorsk as `nb`/`nn`
	 * (e.g. Windows reports `nb-NO`), but `no` is the canonical Norwegian
	 * identifier downstream (backend language records, theme category
	 * matching in themedata). Normalize before the glLanguages lookup so
	 * `nb`/`nn` never leak through as the resolved locale.
	 */
	if (locale === 'nb' || locale === 'nn') {
		locale = 'no';
	} else if (locale.startsWith('nb-') || locale.startsWith('nn-')) {
		locale = `no-${locale.split('-')[1]}`;
	}

	if (window.glLanguages.indexOf(locale) < 0) {
		if (locale.length > 2 && window.glLanguages.indexOf(locale.slice(
			0,
			2,
		)) >= 0) {
			locale = locale.slice(
				0,
				2,
			);
		} else {
			let match;

			if (locale.length == 2) {
				// Search for more specific match
				match = _.find(
					window.glLanguages,
					(l) => l.slice(
						0,
						2,
					) == locale,
				);
			}

			if (match) {
				locale = match;
			} else {
				// No match, fall back to English rather than an arbitrary array entry
				locale = 'en';
			}
		}
	}

	return locale;
};

export default getLocale;
